const checkout = {
  'cardNumber': 'required',
  'cardName': 'required',
  'cardExpirationMonth': 'required',
  'cardExpirationYear': 'required',
  'cardCVC': 'required',
};

export {
  checkout
};